import { defineAsyncComponent } from 'vue';
import VueSplide from '@splidejs/vue-splide';
import '@splidejs/splide/dist/css/themes/splide-skyblue.min.css';
import { mountApp, app } from '@/js/app-entries/app-entry-points/global';

const LatestNewsAndVideos = defineAsyncComponent(() => import('@/js/global/widgets/LatestNewsAndVideos.vue'));
const TrackerEmbedTippy = defineAsyncComponent(() => import('@/js/components/Tippy/TrackerEmbedTippy/TrackerEmbedTippy.vue'));

if (document.querySelector('converter')) {
    const Converter = defineAsyncComponent(() => import('@/js/cryptocurrencies/converter/Converter.vue'));
    app.component('Converter', Converter);
}

app.use(VueSplide);

app.component('LatestNewsAndVideos', LatestNewsAndVideos);
app.component('TrackerEmbedTippy', TrackerEmbedTippy);

mountApp();
